import React from "react";

import { CashbackSettingsFields } from "../../../../components/CashbackSettingsFields";
import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import { FormInput, InputDate } from "../../../../components/Input";
import { MobileSavingsFormProps } from "./types";

export const MobileSavingsForm: React.FC<MobileSavingsFormProps> = ({
  control,
  isSubmitting,
}) => {
  return (
    <>
      <Card>
        <CardLabel htmlFor="mobile-saving-name">Saving name *</CardLabel>
        <FormInput
          id="mobile-saving-name"
          required
          name="name"
          control={control}
          rules={{
            required: "Name is required!",
            minLength: {
              value: 3,
              message: "Name should have more than 3 letters!",
            },
          }}
          handleClear={false}
          disabled={isSubmitting}
          placeholder="e.g. Emergency Fund"
          autoFocus={true}
          variant="title"
        />
      </Card>

      <Card>
        <CardLabel htmlFor="mobile-saving-institution">Institution</CardLabel>
        <FormInput
          id="mobile-saving-institution"
          name="institution"
          control={control}
          handleClear={false}
          disabled={isSubmitting}
          placeholder="e.g. Revolut"
        />
        <HelperText>
          Optional — the bank or provider holding this saving.
        </HelperText>

        <CardLabel htmlFor="mobile-saving-start-date">Start date *</CardLabel>
        <InputDate
          id="mobile-saving-start-date"
          name="startDate"
          control={control}
          rules={{ required: "Start date is required!" }}
          disabled={isSubmitting}
          maxDate={new Date()}
          placeholder="YYYY/MM/DD"
        />
        <HelperText>When you opened this saving.</HelperText>
      </Card>
      <CashbackSettingsFields
        control={control}
        disabled={isSubmitting}
        mobile
      />
    </>
  );
};
